// extracted by mini-css-extract-plugin
export default {"wrapper":"GameOver_wrapper__9dOWr","text_box":"GameOver_text_box__TlS6n","link":"GameOver_link__q508E","image_box":"GameOver_image_box__OEduU"};